import { computed, useAsync } from '@nuxtjs/composition-api';
import { Store } from 'vuex';
import { createNamespacedHelpers } from 'vuex-composition-helpers';

import rainbowImages from '~/consts/rainbowImages';
import { UseRainbowContext } from '~/context/RainbowContext';

const { useGetters: useGettersObrazki } = createNamespacedHelpers('obrazkiBase64');

const fillMapIcons = () => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const { store }: { store: Store<any> } = UseRainbowContext();
  const markerBiuraImage = rainbowImages.markerBiura;
  const { getImage } = useGettersObrazki(['getImage']);
  const markerBiura = computed(() => getImage.value(markerBiuraImage.url));

  useAsync(async () => {
    if (!markerBiura.value) await store.dispatch('obrazkiBase64/fetchImage', markerBiuraImage);

    return true;
  });
};
export default fillMapIcons;
